<!-- Navigation
================================================== -->
<div class="navigation-wrap rana-header" [class.rana-header-scrolled]="scrolled">
    <div class="rana-header-inner">
        <div class="section full-width-mega-menu">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <nav class="navbar navbar-expand-xl navbar-light">
                            <a class="navbar-brand animsition-link rana-header-brand" routerLink="/home"><img
                                    src="./assets/img/rana-logo.png"
                                    alt="logo"/></a>
                            <button class="navbar-toggler" type="button" data-toggle="collapse"
                                    data-target="#navbarSupportedContent"
                                    aria-controls="navbarSupportedContent" aria-expanded="false"
                                    aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>

                            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul class="navbar-nav mr-xl-4 ml-auto pt-4 pt-xl-0 rana-header-nav">
                                    <!--                 &lt;!&ndash; <li class="nav-item dropdown ">-->
                                    <!--                    <a class="nav-link active" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"href="javascript:" routerLink="/home"> <i class='uil uil-home size-19 '></i>Home</a>-->
                                    <!--                  </li>&ndash;&gt;-->

                                    <li class="nav-item dropdown">
                                        <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true"
                                           aria-expanded="false"
                                           href="javascript:"><i class="uil uil-file-medical-alt size-19"></i>About
                                            Us</a>
                                        <div class="dropdown-menu">
                                            <ul class="p-0 m-0 scrollable-dropdown">
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/about-rana"><i
                                                            class="uil uil-user size-19 mr-2 pr-1"></i>About
                                                        RANA</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/vision"><i
                                                            class="uil uil-eye size-19 mr-2 pr-1"></i>RANA
                                                        Vision</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/constitution"><i
                                                            class="uil uil-star size-19 mr-2 pr-1"></i>Our
                                                        Constitution</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/committee"><i
                                                            class="uil uil-star size-19 mr-2 pr-1"></i>National
                                                        Leadership</a>
                                                </li>
                                                <li class="nav-item" *ngIf="userRole?.CHAPTER?.includes('CREATE')">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/chapter-home/{{ necChapter?.id }}"><i
                                                            class="uil uil-location-pin-alt size-19 mr-2 pr-1"></i>{{ necChapter?.name }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true"
                                           aria-expanded="false"
                                           href="javascript:"><i class="uil uil-book-reader size-19"></i>Chapters</a>
                                        <div class="dropdown-menu">
                                            <ul class="p-0 m-0 scrollable-dropdown">

                                                <li class="nav-item" *ngIf="userRole?.CHAPTER?.includes('CREATE')">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/chapter"><i
                                                            class="uil uil-location-pin-alt size-19 mr-2 pr-1"></i>Add
                                                        New Chapter</a>
                                                </li>
                                                <li class="nav-item" *ngFor="let item of chapterList; let i = index">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/chapter-home/{{ item.id }}"><i
                                                            class="uil uil-location-pin-alt size-19 mr-2 pr-1"></i>{{ item.name }}</a>
                                                </li>

                                            </ul>


                                        </div>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true"
                                           aria-expanded="false"
                                           href="javascript:"><i class="uil uil-gift size-19"></i>Community Services</a>
                                        <div class="dropdown-menu">
                                            <ul class="p-0 m-0">
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/biz-directory"><i
                                                            class="uil uil-user size-19 mr-2 pr-1"></i>Business
                                                        Directory</a>
                                                </li>
                                                <!-- Matrimonial menu temporarily disabled
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/matrimonial-home"><i
                                                            class="uil uil-heart size-19 mr-2 pr-1"></i>Matrimonial</a>
                                                </li>
                                                -->
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/medical-help"><i
                                                            class="uil uil-file size-19 mr-2 pr-1"></i>Medical Help</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/education"><i
                                                            class="uil uil-file size-19 mr-2 pr-1"></i>Education</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true"
                                           aria-expanded="false"
                                           href="javascript:"><i class="uil uil-microphone size-19"></i> Events</a>
                                        <div class="dropdown-menu">
                                            <ul class="p-0 m-0">
                                                <!--li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/biz-conf"><i
                                                            class="uil uil-users-alt size-19 mr-2 pr-1"></i>Business
                                                        Conference 2026</a>
                                                </li-->

                                                <li class="nav-item" *ngFor="let event of necOpenEvents">
                                                  <a class="dropdown-item animsition-link" routerLink="/event-register/{{ event.id }}"><i
                                    class="uil uil-user size-19 mr-2 pr-1"></i>{{ event.title }}</a>
                                                </li>
                                                <!--li class="nav-item">
                                                  <a class="dropdown-item animsition-link" href="javascript:" routerLink="/news-events"><i
                                                      class="uil uil-user size-19 mr-2 pr-1"></i>Southwest - Annual Event</a>
                                                </li>
                                                <li class="nav-item">
                                                  <a class="dropdown-item animsition-link" href="javascript:" routerLink="/gallery"><i
                                                      class="uil uil-location size-19 mr-2 pr-1"></i>Arizona - Picnic 2025</a>
                                                </li-->
                                            </ul>
                                        </div>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true"
                                           aria-expanded="false"
                                           href="javascript:"><i class="uil uil-microphone size-19"></i>Media &
                                            Downloads</a>
                                        <div class="dropdown-menu">
                                            <ul class="p-0 m-0">
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/gen-bd-mom"><i
                                                            class="uil uil-user size-19 mr-2 pr-1"></i>General Body
                                                        Meetings</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/nec-mom"><i
                                                            class="uil uil-user size-19 mr-2 pr-1"></i>NEC
                                                        Minutes of Meeting</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="dropdown-item animsition-link"
                                                       href="assets/pdf/Nomination_Form_secretary_NEC.pdf"
                                                       download="Nomination_Form_secretary_NEC.pdf"><i
                                                            class="uil uil-file size-19 mr-2 pr-1"></i>Nomination Form
                                                        NEC/CEC/BOT</a>
                                                </li>
                                                <!--li class="nav-item">
                                                  <a class="dropdown-item animsition-link" href="javascript:" routerLink="/gallery"><i
                                                      class="uil uil-location size-19 mr-2 pr-1"></i>Gallery</a>
                                                </li -->
                                                <!-- Public Document Management menu temporarily disabled
                                                <li class="nav-item" *ngIf="userRole?.DOCUMENT?.includes('CREATE') || userRole?.DOCUMENT?.includes('READ')">
                                                    <a class="dropdown-item animsition-link" href="javascript:"
                                                       routerLink="/admin/documents"><i
                                                            class="uil uil-file-upload-alt size-19 mr-2 pr-1"></i>Public
                                                        Document Management</a>
                                                </li>
                                                -->
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                                <div class="rana-header-actions mt-4 mt-xl-0" *ngIf="isDivVisible || username">
                                    <div class="rana-notification-trigger" *ngIf="notificationCount > 0">
                                        <a href="javascript:" (click)="toggleNotificationPopup($event)"
                                           class="rana-header-action-btn position-relative" title="Notifications">
                                            <i class="uil uil-bell size-20"></i>
                                            <span class="rana-header-badge">{{ notificationCount }}</span>
                                        </a>
                                        <div class="rana-notification-popup" *ngIf="showNotificationPopup"
                                             (click)="$event.stopPropagation()">
                                            <div class="rana-notification-popup-item" *ngFor="let n of notifications">
                                                <strong>{{ n.message }}</strong>
                                                <small>{{ n.addedDate | date:'medium' }}</small>
                                                <a *ngIf="n.targetURL" [routerLink]="n.targetURL"
                                                   (click)="showNotificationPopup = false">View details</a>
                                            </div>
                                        </div>
                                    </div>
                                    <a routerLink="/profile" class="rana-header-action-btn" title="My Profile">
                                        <i class="uil uil-user size-20"></i>
                                    </a>
                                    <a routerLink="/login" class="rana-header-action-btn" title="Sign Out">
                                        <i class="uil uil-sign-out-alt size-20"></i>
                                    </a>
                                </div>

                                <div class="pb-3 pb-xl-0"></div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade modal-small" id="modal-notification" tabindex="-1" role="dialog"
     aria-labelledby="modal-notification" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <div class="container-fluid">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="uil uil-multiply"></i>
                    </button>
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <h5 class="mb-3">Notifications</h5>
                        </div>
                        <div class="col-12 text-center">
                            <p class="mb-0">New Notification goes here</p>
                        </div>
                        <div class="col-12 text-center mt-5">
                            <button data-dismiss="modal" type="button" class="btn btn-dark">
                                Thanks
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
